themeBase.onDOMContentLoadedTrigger(() => {
  const getFeaturedCollectionSection = element => element && element.closest("[id^='FeaturedCollectionSection-']");
  const getSectionId = section => section.id.replace('FeaturedCollectionSection-', '');

  const syncTabsMetadata = section => {
    if (!section) return;

    const sectionId = getSectionId(section);
    const tabBlocks = Array.from(section.querySelectorAll('.featured-collection-tabs__blocks > *'));
    // Retailercart: sections built with the older "collection" blocks have no tab metadata elements.
    // Keep the titles and links rendered by Liquid instead of replacing them with "Collection".
    if (!tabBlocks.length) return;
    const tabTitles = tabBlocks.map(block => (block.getAttribute('data-featured-tab-title') || '').trim() || 'Collection');
    const tabUrls = tabBlocks.map(block => (block.getAttribute('data-featured-tab-url') || '').trim());

    section.querySelectorAll('.content-header__collections, .heading-wrapper__collections').forEach(wrapper => {
      wrapper.querySelectorAll('label.title').forEach((label, index) => {
        label.textContent = tabTitles[index] || 'Collection';
        label.setAttribute('for', `FeaturedCollectionButton-${sectionId}-${index + 1}`);
      });
    });

    section.querySelectorAll('.section-buttons.buttons-grid-small-up, .g-col-12.section-buttons.buttons-grid-small-up').forEach(container => {
      container.querySelectorAll('a').forEach((link, index) => {
        const tabUrl = tabUrls[index] || '';

        if (tabUrl) {
          link.setAttribute('href', tabUrl);
          link.removeAttribute('role');
          link.removeAttribute('aria-disabled');
        } else {
          link.removeAttribute('href');
          link.setAttribute('role', 'link');
          link.setAttribute('aria-disabled', 'true');
        }
      });
    });
  };

  document.querySelectorAll("[id^='FeaturedCollectionSection-']").forEach(syncTabsMetadata);

  document.addEventListener('change', e => {
    const input = e.target.closest('.featured-collection-button');
    if (!input || input.type !== 'radio' || !input.checked) return;

    const id = input.id;
    const tpl = document.querySelector(`template[data-template-id='${id}']`);

    if (tpl) {
      const clone = tpl.content.cloneNode(true);

      tpl.replaceWith(clone);
      setTimeout(() => {
        input.checked = true;
        window.lazyImages.find();
      }, 0);
    }

    const featuredCollectionSection = getFeaturedCollectionSection(input);
    syncTabsMetadata(featuredCollectionSection);

    if (!themeBase.isDesktop) {
      const section = input.closest('section');
      const currentScroll = section.getAttribute('data-scrolling') || 0;

      section.querySelectorAll('.content-header__collections, .heading-wrapper__collections').forEach(el => el.scrollLeft = currentScroll);
    }
  });

  window.scrollAllToOne = function(element) {
    requestAnimationFrame(() => element.closest('section').setAttribute('data-scrolling', element.scrollLeft));
  };
});